import { render } from "./settings.vue?vue&type=template&id=4950d2dd&scoped=true"
import script from "./settings.vue?vue&type=script&lang=js"
export * from "./settings.vue?vue&type=script&lang=js"

import "./settings.vue?vue&type=style&index=0&id=4950d2dd&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\taxes-calculator\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4950d2dd"]])

export default __exports__